import { format as d3Format } from "d3-format";

const percentageFormat = d3Format(".0%");

export { percentageFormat };
